import React, { useState } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import Classes from "../Profile.module.css";
import MenteeLevelDropDown from "./DropDowns/MenteeLevelDropDown";
import LanguagesDropDown   from "./DropDowns/LanguagesDropDown";
import AvailabilityDropDown from "./DropDowns/AvailabilityDropDown";

export default function SessionDetails({ initial={}, saveProfile }) {
  const [form,setForm]=useState({
    expectSession:   initial.expectSession||"",
    menteeLevel:     initial.menteeLevel||[],
    languagesSpoken: initial.languagesSpoken||[],
    availability:    initial.availability||[],
  });
  const [saving,setSaving] = useState(false);

  const setArr=(k)=>(v)=>setForm(p=>({...p,[k]:v}));

  const submit=async e=>{
    e.preventDefault();
    setSaving(true);
    await saveProfile({ sessionDetails: form });
    setSaving(false);
  };

  return (
    <>
      <Backdrop open={saving} sx={{ zIndex:1301, color:"#fff" }}>
        <CircularProgress color="inherit"/>
      </Backdrop>

      <form className={Classes.infoCon} onSubmit={submit}>
        <h3>Session Details</h3>

        <div className={Classes.infoConMiddle}>
          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>What Can Mentees Expect From a Session With You?</h5>
              <input
                name="expectSession"
                className={Classes.inputField}
                placeholder="Provide a short answer"
                value={form.expectSession}
                onChange={e=>setForm(p=>({...p,expectSession:e.target.value}))}
              />
            </div>
          </div>

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Preferred Mentee Level</h5>
              <MenteeLevelDropDown selected={form.menteeLevel} onChange={setArr("menteeLevel")}/>
            </div>
          </div>

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Languages Spoken</h5>
              <LanguagesDropDown selected={form.languagesSpoken} onChange={setArr("languagesSpoken")}/>
            </div>
          </div>

          <div className={Classes.flexColGroup}>
            <div className={Classes.flexCol1}>
              <h5 className={Classes.label}>Availability</h5>
              <AvailabilityDropDown selected={form.availability} onChange={setArr("availability")}/>
            </div>
          </div>
        </div>

        <div className={Classes.flexEnd}>
          <button type="submit" className={Classes.saveBtn}><h5>Save</h5></button>
        </div>
      </form>
    </>
  );
}
